<script lang="ts">
	import { override } from '$src/lib/utils/classnames'

	interface Props {
		title: string
		isActive?: boolean
		children?: import('svelte').Snippet
		onhover?: (title: string) => void
	}

	let { title, isActive = false, children, onhover }: Props = $props()

	function handleOnHover(event: MouseEvent) {
		event.preventDefault()
		event.stopPropagation()
		onhover?.(title)
	}

	function handleOnMouseLeave(event: MouseEvent) {
		event.preventDefault()
		event.stopPropagation()
		onhover?.(null)
	}

	let condensedClasses = $derived(
		override(
			'mt-[2px] flex flex-col justify-center items-center rounded-sm pt-1 text-xs leading-6 transition-color group-hover:text-white',
			isActive ? 'text-white' : 'text-brand-gray-4',
		),
	)
</script>

<li
	onmouseenter={handleOnHover}
	onmouseleave={handleOnMouseLeave}
	class="group flex flex-col justify-center items-center rounded-sm py-2 text-xs leading-6 cursor-pointer"
>
	{@render children?.()}
	<span class={condensedClasses}>{title}</span>
</li>
